import { z } from 'zod';
import { ProcessType } from '../enums/process-type.enum';
import { UseSchema } from '../../common';

const csvSettingsSchema = z.object({
  version: z.number(),
  filters: z
    .object({
      version: z.number().optional(),
      conditions: z.array(
        z.object({
          id: z.string(),
          property: z.string(),
          operator: z.enum([
            'after',
            'before',
            'contains',
            'equals',
            'greaterOrEqual',
            'greaterThan',
            'isEmpty',
            'isFalse',
            'isNotEmpty',
            'isTrue',
            'lessOrEqual',
            'lessThan',
            'notContains',
            'notEquals',
          ]),
          value: z.string(),
        }),
      ),
      logicOperators: z.array(z.enum(['AND', 'OR'])),
      ifcTypeFilters: z.array(z.string()).optional(),
    })
    .nullable(),
  grouping: z
    .object({
      version: z.number().optional(),
      criteria: z.array(z.object({ id: z.string(), property: z.string() })),
    })
    .nullable(),
});

export const runProcessDtoSchema = z.object({
  model3dEntryId: z.string().uuid().describe('The ID of the model to convert'),
  type: z.nativeEnum(ProcessType).describe('The type of conversion'),
  csvSettings: csvSettingsSchema
    .optional()
    .describe('Viewer filter/grouping conditions applied to CSV/XLSX export'),
});

@UseSchema(runProcessDtoSchema)
export class RunProcessDto {}
export interface RunProcessDto extends z.infer<typeof runProcessDtoSchema> {}
